(function () {
  const setSelected = () => {
    const productCards = document.querySelectorAll(".product-grid-item");
    productCards.forEach((productCard) => {
      const swatch = productCard.querySelector(".swatch__button");
      if (swatch) {
        swatch.classList.add("selected");
      }
    });
  };
  document.addEventListener("DOMContentLoaded", () => {
    setTimeout(setSelected, 700);
  });
})();
